export default __webpack_public_path__ + "static/media/cancel.43637936.svg";